import craftProductsCoverImage from '../../../assets/images/craftProducts/craftProductsCoverImage.webp'
import craftProduct1 from '../../../assets/images/craftProducts/brynza-spices-olive-oil-vogni-provansu-pastoral-50-fat-550g.webp'
import craftProduct2 from '../../../assets/images/craftProducts/brynza-herbs-olive-oil-alpiiski-travy-pastoral-50-fat-550g.webp'
import craftProduct3 from '../../../assets/images/craftProducts/brynza-spices-herbs-olive-oil-buket-provansu-pastoral-50-fat-550g.webp'
import craftProductsCoverImageMobile from '../../../assets/images/craftProducts/craftProductsCoverImageMobile.webp'


export const CraftProductsArrRu = [
    {
        path: "/ru/craft-products/brynza-spices-olive-oil-vogni-provansu-pastoral-50-fat-550g/",
        category: "craft",
        metaTitle: "Брынза со специями в оливковом масле «Огни Прованса»",
        metaDescription: "Брынза со специями в оливковом масле «Огни Прованса»",
        coverImage: craftProductsCoverImage,
        coverImageMobile: craftProductsCoverImageMobile,
        coverTitle: "Крафтовые продукты",
        aboutImage: craftProduct1,
        aboutTitle: "Брынза со специями в оливковом масле «Огни Прованса» ТМ «Pastoral» 50% жирности в сухом веществе, 550 g (г)",
        aboutStats: [
            "25,7 g (г)", "26,3 g (г)", "0 g (г)", "340 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "550 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "стекло",
            },
            {
                title: "Состав: ",
                desc: "брынза (молоко цельное, молоко обезжиренное, соль пищевая, консервант — калий азотнокислый, натуральный краситель аннато, гранулят хлорида кальция, закваски мезофильных и термофильных бактерий, молокосвертывающий фермент) — 54%; оливковое масло — 45%; специи (сушёные томаты с чесноком и базиликом, паприка молотая копчёная, паприка молотая), смесь трав «Прованская» — 1%.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>при температуре от 0ºC до 6ºC и относительной влажности воздуха от 80% до 85% включительно — не более 21 суток с даты фасовки.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 15.5 – 05409745 – 002:2025.",
            },
        ],
        categoryInfo: [
            "Уникальные рецепты – мы отбираем лучшие продукты из мировых молочных практик.",
            "Органолептический тест – каждый новый продукт проходит дегустацию потребителями.",
            "Запоминающиеся вкусы – настоящий гастрономический опыт, к которому хочется возвращаться.",
    
        ],
    },
    {
        path: "/ru/craft-products/brynza-herbs-olive-oil-alpiiski-travy-pastoral-50-fat-550g/",
        category: "craft",
        metaTitle: "Брынза с травами в оливковом масле «Альпийские травы»",
        metaDescription: "Брынза с травами в оливковом масле «Альпийские травы»",
        coverImage: craftProductsCoverImage,
        coverImageMobile: craftProductsCoverImageMobile,
        coverTitle: "Крафтовые продукты",
        aboutImage: craftProduct2,
        aboutTitle: "Брынза с травами в оливковом масле «Альпийские травы» ТМ «Pastoral» 50% жирности в сухом веществе, 550 g (г)",
        aboutStats: [
            "25,7 g (г)", "26,3 g (г)", "0 g (г)", "340 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "550 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "стекло",
            },
            {
                title: "Состав: ",
                desc: "брынза (молоко цельное, молоко обезжиренное, соль пищевая, консервант — калий азотнокислый, натуральный краситель аннато, гранулят хлорида кальция, закваски мезофильных и термофильных бактерий, молокосвертывающий фермент) — 54%; оливковое масло — 45%; смесь трав «Прованская» — 1%.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>при температуре от 0ºC до 6ºC и относительной влажности воздуха от 80% до 85% включительно — не более 21 суток с даты фасовки.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 15.5 – 05409745 – 002:2025.",
            },
        ],
        categoryInfo: [
            "Уникальные рецепты – мы отбираем лучшие продукты из мировых молочных практик.",
            "Органолептический тест – каждый новый продукт проходит дегустацию потребителями.",
            "Запоминающиеся вкусы – настоящий гастрономический опыт, к которому хочется возвращаться.",
    
        ],
    },
    {
        path: "/ru/craft-products/brynza-spices-herbs-olive-oil-buket-provansu-pastoral-50-fat-550g/",
        category: "craft",
        metaTitle: "Брынза со специями и травами в оливковом масле «Букет Прованса»",
        metaDescription: "Брынза со специями и травами в оливковом масле «Букет Прованса»",
        coverImage: craftProductsCoverImage,
        coverImageMobile: craftProductsCoverImageMobile,
        coverTitle: "Крафтовые продукты",
        aboutImage: craftProduct3,
        aboutTitle: "Брынза со специями и травами в оливковом масле «Букет Прованса» ТМ «Pastoral» 50% жирности в сухом веществе, 550 g (г)",
        aboutStats: [
            "25,7 g (г)", "26,3 g (г)", "0 g (г)", "340 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Масса/Объём: ",
                desc: "550 g (г)",
            },
            {
                title: "Упаковка: ",
                desc: "стекло",
            },
            {
                title: "Состав: ",
                desc: "брынза (молоко цельное, молоко обезжиренное, соль пищевая, консервант — калий азотнокислый, натуральный краситель аннато, гранулят хлорида кальция, закваски мезофильных и термофильных бактерий, молокосвертывающий фермент) — 54%; оливковое масло — 45%; специи (сушёные томаты с чесноком и базиликом, паприка молотая копчёная, паприка молотая), смесь трав «Прованская» — 1%.",
            },
            {
                title: "Срок годности: ",
                desc: (
                    <>при температуре от 0ºC до 6ºC и относительной влажности воздуха от 80% до 85% включительно — не более 21 суток с даты фасовки.</>
                ),

            },
            {
                title: "Сертификат качества: ",
                desc: "ТУ У 15.5 – 05409745 – 002:2025.",
            },
        ],
        categoryInfo: [
            "Уникальные рецепты – мы отбираем лучшие продукты из мировых молочных практик.",
            "Органолептический тест – каждый новый продукт проходит дегустацию потребителями.",
            "Запоминающиеся вкусы – настоящий гастрономический опыт, к которому хочется возвращаться.",
    
        ],
    },
]